<template>
  <div>
    <jump-header />
    <div class="activity-img">
      <img class="activity-poster" :src="activityDetail.pictureUrl" alt="" />
      <div class="bg-filter">{{ activityDetail.title }}</div>
    </div>
    <div class="tab-wrapper">
      <div
        :class="['tab-item', currentActive === 0 ? 'tab-item-active' : '']"
        @click="toggleCurrentActive(0)"
      >
        活动作品
        <div class="tab-item-solid" v-if="currentActive === 0"></div>
      </div>
      <div
        :class="['tab-item', currentActive === 1 ? 'tab-item-active' : '']"
        @click="toggleCurrentActive(1)"
      >
        活动简介
        <div class="tab-item-solid" v-if="currentActive === 1"></div>
      </div>
    </div>
    <div class="join-btn">前往APP参与活动</div>
    <div style="max-width: 100%; overflow: hidden" v-if="currentActive === 1">
      <div style="max-width: 100%" id="staticHtml" v-html="staticHtml"></div>
    </div>
    <van-list
      v-if="currentActive === 0"
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了~"
      @load="onLoad"
    >
      <div
        class="work-item"
        v-for="item in workList"
        :key="item.id"
        @click="toVoteItemDetail(item)"
      >
        <img
          v-if="item.rankNum === 1 || item.rankNum === 2 || item.rankNum === 3"
          :src="require(`@/assets/image/icon_${item.rankNum}.png`)"
          alt=""
          class="work-item-icon"
        />
        <div v-else class="work-item-num">{{ item.rankNum }}</div>
        <div class="work-item-center text-line-1">
          <img :src="item.publicImage" alt="" />
          <div class="center-right text-line-1">
            <div class="center-right-name text-line-1">{{ item.name }}</div>
            <span class="center-right-nickname">{{ item.nickName }}</span>
            <div class="center-right-desc">
              <span class="desc-thumbs">获赞数:{{ item._voteNum }}</span>
              <span class="desc-number">No.{{ item.orderNum }}</span>
            </div>
          </div>
        </div>
        <div class="work-item-btn">点赞</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { queryActivityDetials, selectVoteRank } from "@/http/api";
import JumpHeader from "@/components/Base/JumpHeader";
import { get } from "@/http/request";
import { fixNumToBig } from "@/assets/js/util";

export default defineComponent({
  name: "VoteActivity",
  components: {
    JumpHeader
  },
  setup() {
    const router = useRouter();
    const workList = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const activityId = ref(267);
    const staticHtml = ref(null);
    const currentActive = ref(0);
    const activityDetail = ref({});
    let page = 1;

    const getActivityDetails = async () => {
      const { code, data } = await queryActivityDetials({
        activityId: activityId.value
      });
      if (code === 1) {
        activityDetail.value = data;
      }
    };

    const getStaticHtml = async () => {
      const { data } = await get(activityDetail.value.htmlUrl);
      staticHtml.value = data;
    };

    const getVoteList = async () => {
      const { code, data } = await selectVoteRank({
        activityId: activityId.value,
        voteNum: 1,
        rows: 10,
        page
      });
      loading.value = false;
      if (code === 1) {
        data.pageList.forEach(item => {
          item._voteNum = fixNumToBig(item.voteNum);
        });
        workList.value = [...workList.value, ...data.pageList];
        if (data.totalPage <= page) {
          finished.value = true;
        }
      }
      console.log(data);
    };

    const toggleCurrentActive = curActive => {
      const _currentActive = currentActive.value;
      if (curActive === _currentActive) {
        return;
      }
      currentActive.value = curActive;
      window.scrollTo(0, 0);
    };

    const onLoad = () => {
      page++;
      getVoteList();
    };

    const toVoteItemDetail = item => {
      console.log(item);
      router.push({
        name: "VoteActivityItem",
        params: {
          item: JSON.stringify(item)
        }
      });
    };

    onMounted(async () => {
      getVoteList();
      await getActivityDetails();
      await getStaticHtml();
    });

    return {
      loading,
      finished,
      workList,
      staticHtml,
      currentActive,
      activityDetail,
      onLoad,
      toVoteItemDetail,
      toggleCurrentActive
    };
  }
});
</script>

<style lang="scss" scoped>
.activity-img {
  position: relative;
  width: 100%;
  margin-top: 40px;

  .activity-poster {
    width: 100%;
    height: 270px;
    min-height: 270px;
  }

  .bg-filter {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px !important;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
    box-sizing: border-box;
    padding: 0 13px;
    font-size: 16px;
    color: #fffefe;
    line-height: 20px;
  }
}

.tab-wrapper {
  position: sticky;
  top: 45px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 13px;
  background: #fff;
  border-bottom: 1px solid rgba(233, 233, 233, 0.8);
  z-index: 9999;

  .tab-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 45px !important;
    color: #333;
    font-size: 18px;
    letter-spacing: 1px;
    text-indent: 1px;

    .tab-item-solid {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 1px;
      background: #fa3d70;
    }
  }

  .tab-item-active {
    font-weight: bold;
    color: #fa3d70;
  }
}

.join-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 60px);
  margin: 30px auto 0;
  height: 50px;
  background: linear-gradient(to right, #fa3d70, #fa5d70);
  border-radius: 8px;
  color: #fffefe;
  font-size: 18px;
  letter-spacing: 2px;
  text-indent: 2px;
}

.work-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: calc(100% - 60px);
  margin: 20px 30px 0 30px;
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #f1f1f1;

  .work-item-icon {
    width: 25px;
    height: 25px;
  }

  .work-item-num {
    width: 25px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  .work-item-center {
    display: flex;
    align-items: center;
    flex: 1;
    margin: 0 10px 0 15px;

    &:last-child {
      border-bottom: none;
    }

    & > img {
      width: 65px;
      height: 65px;
      border-radius: 4px;
      margin-right: 5px;
    }

    .center-right {
      display: flex;
      flex: 1;
      flex-direction: column;
      height: 65px;
      justify-content: space-between;

      .center-right-name {
        display: inline-block;
        font-weight: bold;
        font-size: 16px;
        color: #111;
      }

      .center-right-nickname {
        display: inline-block;
        font-weight: bold;
        font-size: 14px;
        color: #111;
      }

      .center-right-desc {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 14px;

        .desc-thumbs {
          margin-right: 10px;
        }
      }
    }
  }

  .work-item-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55px;
    height: 28px;
    background: linear-gradient(180deg, #fa7077 0%, #f5bc89 100%);
    border-radius: 10px;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
